import Chart from "chart.js/dist/chart.js";

export function setupLineChartHook() {
  return {
    labels() {
      return JSON.parse(this.el.dataset.labels);
    },
    views() {
      return JSON.parse(this.el.dataset.views);
    },
    users() {
      return JSON.parse(this.el.dataset.users);
    },
    currentChart: null,
    mounted() {
      Chart.register();
      this.renderChart();

      this.handleEvent("rebuild", () => {
        if (this.currentChart) {
          this.currentChart.destroy();
        }
        this.renderChart();
      });
    },
    updated() {
      if (this.currentChart) {
        this.currentChart.destroy();
      }
      this.renderChart();
    },
    renderChart() {
      const ctx = this.el.getContext("2d");

      const viewsGradient = ctx.createLinearGradient(0, 0, 0, 300);
      viewsGradient.addColorStop(0, "rgba(139, 92, 246, 0.3)");
      viewsGradient.addColorStop(1, "rgba(139, 92, 246, 0.02)");

      const usersGradient = ctx.createLinearGradient(0, 0, 0, 300);
      usersGradient.addColorStop(0, "rgba(16, 185, 129, 0.2)");
      usersGradient.addColorStop(1, "rgba(16, 185, 129, 0.02)");

      this.currentChart = new Chart(ctx, {
        type: "line",
        data: {
          labels: this.labels(),
          datasets: [
            {
              label: "Page Views",
              data: this.views(),
              borderColor: "rgb(139, 92, 246)",
              backgroundColor: viewsGradient,
              borderWidth: 2,
              fill: true,
              tension: 0.3,
              pointRadius: 3,
              pointHoverRadius: 6,
              pointBackgroundColor: "rgb(139, 92, 246)",
              pointBorderColor: "#fff",
              pointBorderWidth: 2,
            },
            {
              label: "Unique Visitors",
              data: this.users(),
              borderColor: "rgb(16, 185, 129)",
              backgroundColor: usersGradient,
              borderWidth: 2,
              fill: true,
              tension: 0.3,
              pointRadius: 3,
              pointHoverRadius: 6,
              pointBackgroundColor: "rgb(16, 185, 129)",
              pointBorderColor: "#fff",
              pointBorderWidth: 2,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          interaction: {
            mode: "index",
            intersect: false,
          },
          plugins: {
            legend: {
              display: true,
              position: "top",
              align: "end",
              labels: {
                usePointStyle: true,
                pointStyle: "circle",
                padding: 20,
                font: { size: 12 },
              },
            },
            datalabels: {
              display: false,
            },
            tooltip: {
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              padding: 12,
              cornerRadius: 8,
              titleFont: { size: 13 },
              bodyFont: { size: 12 },
            },
          },
          scales: {
            x: {
              grid: { display: false },
              ticks: {
                font: { size: 11 },
                color: "#9ca3af",
                maxTicksLimit: 12,
              },
            },
            y: {
              beginAtZero: true,
              grid: {
                color: "rgba(0, 0, 0, 0.04)",
                drawBorder: false,
              },
              ticks: {
                font: { size: 11 },
                color: "#9ca3af",
                padding: 8,
              },
            },
          },
        },
      });
    },
  };
}
